


















































































import { UserModule } from '@/store/modules/user';
import ItemCol from './ItemCol.vue';
import BlockHeader from './BlockHeader.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'personalProfile',
  components: {
    ItemCol,
    BlockHeader
  }
})
export default class extends Vue {
  @Prop() public studentEducationDtos!: any;

  public handleEdit() {
    const stuid = this.$route.params.id + '';
    const agentId = UserModule.fkAgentId;
    this.$router.push({ name: 'studentApplicationForm', params: { stuid }, query: { agid: agentId, activeNames: 'education' }});
  }
}
